import axios from 'axios';
import { tokenConfig } from './authActions';
import store from '../store';

export const addHistory = async (path: string, tokenId: any) : Promise<any> => {
  return new Promise((resolve) => {
  axios
    .post('/api/histories', { path, tokenId }, tokenConfig(store.getState))
    .then(res => 
      resolve(res.data)
    )
    .catch(err => {
      resolve(false);
      console.log("err addHistory", err)
    });
  });
};
